<template>
  <footer class="organism-site-footer">
    <!-- Top Section: Navigation Links -->
    <div class="footer-top">
      <div class="footer-container">
        <div class="footer-column">
          <h3 class="footer-heading">Product</h3>
          <ul class="footer-links-list">
            <li>
              <a @click="scrollToTop" class="footer-link">Explore product</a>
            </li>
            <li>
              <a @click="scrollToPricing" class="footer-link">Pricing</a>
            </li>
          </ul>
        </div>

        <div class="footer-column">
          <h3 class="footer-heading">Features</h3>
          <ul class="footer-links-list">
            <li
              v-for="(feature, index) in features"
              :key="index"
              class="footer-feature"
            >
              {{ feature.title }}
            </li>
          </ul>
        </div>

        <div class="footer-column">
          <h3 class="footer-heading">Resources</h3>
          <ul class="footer-links-list">
            <li>
              <router-link to="/blogs" class="footer-link">Blog</router-link>
            </li>
            <li>
              <router-link to="/how-it-works" class="footer-link"
                >How it works</router-link
              >
            </li>
          </ul>
        </div>

        <div class="footer-column">
          <h3 class="footer-heading">Company</h3>
          <ul class="footer-links-list">
            <li>
              <a
                href="https://www.instagram.com/_skyhost_/"
                target="_blank"
                rel="noopener noreferrer"
                class="footer-link"
              >
                Instagram
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Bottom Section: Brand and Legal -->
    <div class="footer-bottom">
      <div class="footer-container">
        <span class="footer-copyright">© 2025 Skyhost</span>
        <div class="footer-legal">
          <a @click="navigateToPrivacy" class="footer-legal-link">Privacy</a>
          <span class="footer-separator">·</span>
          <a @click="navigateToTerms" class="footer-legal-link">Terms</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "SiteFooter",
  props: {
    features: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    scrollToPricing() {
      // Find the pricing section and scroll to it
      const pricingSection = document.querySelector(
        ".organism-pricing-preview"
      );
      if (pricingSection) {
        pricingSection.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        // Fallback: scroll to top if section not found
        this.scrollToTop();
      }
    },
    navigateToTerms() {
      this.$router.push("/terms");
    },
    navigateToPrivacy() {
      this.$router.push("/privacy");
    },
  },
};
</script>

<style scoped>
.organism-site-footer {
  width: 100%;
  background-color: #000;
}

.footer-top {
  padding: 4rem 5rem 3rem;
}

.footer-bottom {
  padding: 2rem 2rem;
}

.footer-container {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  gap: 3rem;
}

.footer-top .footer-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 3rem;
}

.footer-bottom .footer-container {
  align-items: center;
}

.footer-column {
  display: flex;
  flex-direction: column;
}

.footer-heading {
  font-size: 1rem;
  font-weight: 600;
  color: #fff;
  margin: 0 0 1.5rem 0;
  font-family: system-ui, -apple-system, sans-serif;
}

.footer-links-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.footer-link {
  color: #999;
  text-decoration: none;
  font-size: 0.8rem;
  font-family: system-ui, -apple-system, sans-serif;
  cursor: pointer;
  transition: color 0.2s ease;
}

.footer-link:hover {
  color: #fff;
}

.footer-feature {
  color: #999;
  font-size: 0.8rem;
  font-family: system-ui, -apple-system, sans-serif;
  line-height: 1.5;
}

.footer-brand {
  font-size: 1.25rem;
  font-weight: 700;
  color: #fff;
  font-family: system-ui, -apple-system, sans-serif;
}

.footer-legal {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  color: #999;
  font-family: system-ui, -apple-system, sans-serif;
}

.footer-legal-link {
  color: #999;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease;
}

.footer-legal-link:hover {
  color: #fff;
}

.footer-separator {
  color: #666;
}

.footer-copyright {
  color: #999;
  font-size: 0.75rem;
}

@media (max-width: 968px) {
  .footer-top {
    padding: 3rem 2rem 2rem;
  }

  .footer-bottom {
    padding: 1.5rem 2rem;
  }

  .footer-top .footer-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }
}

@media (max-width: 768px) {
  .footer-top {
    padding: 2.5rem 1.5rem 1.5rem;
  }

  .footer-bottom {
    padding: 1.5rem 1.5rem;
  }

  .footer-top .footer-container {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .footer-bottom .footer-container {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .footer-heading {
    margin-bottom: 1rem;
  }

  .footer-links-list {
    gap: 0.5rem;
  }
}
</style>
